import { useEffect } from 'react'
import { css } from '@emotion/react'
import { observer, inject } from 'mobx-react'
import { useField } from 'react-final-form'
import { SliderWithValueUnderneath, Spacer } from '../../../../components'
import { Page } from '../style'

// primarySlider/spouseSlider are preloaded from backend-computed advice
// (averageMarketSpendingAdvice.*.lifeExpectancyAge), which can predate the
// person's current age the same way a stale retirement age can (GC-21655).
// The native range input clamps its own displayed value to `min`, so a
// stale below-min value looks fine on screen while Final Form still holds
// and resubmits it untouched. Nudge the field up to the floor once age
// makes it invalid, so the corrected value is what actually gets submitted.
function useClampedField(fieldName, minimumAge) {
  const field = useField(fieldName, { subscription: { value: true, touched: true, error: true } })
  const { value, onChange } = field.input

  useEffect(() => {
    if (minimumAge != null && value !== '' && value != null && Number(value) < minimumAge) {
      onChange(minimumAge)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minimumAge])

  return field
}

function ExtendedLifeExpectancy({
  store: { person, spouse },
  primaryFrozenValue,
  spouseFrozenValue,
}) {
  const primaryField = useClampedField('primarySlider', person.age)
  const spouseField = useClampedField('spouseSlider', spouse?.age)

  return (
    <>
      <Page.SliderContainer>
        <Page.SliderLabel>{person.displayName}</Page.SliderLabel>
        <Page.SliderValue>
          <SliderWithValueUnderneath
            min={person.age + ''}
            max={person.age + 85 > 120 ? '120' : (person.age + 85).toString()}
            value={primaryField.input.value}
            onChange={primaryField.input.onChange}
            frozenValue={primaryFrozenValue}
          />
        </Page.SliderValue>
      </Page.SliderContainer>
      {person.includeSpouse && (
        <>
          <Spacer space='8px' />
          <Page.SliderContainer
            css={css`
              margin-top: 50px;
              margin-bottom: 25px;
            `}>
            <Page.SliderLabel>{spouse.firstName}</Page.SliderLabel>
            <Page.SliderValue>
              <SliderWithValueUnderneath
                min={spouse.age + ''}
                max={spouse.age + 85 > 120 ? '120' : (spouse.age + 85).toString()}
                value={spouseField.input.value}
                onChange={spouseField.input.onChange}
                frozenValue={spouseFrozenValue}
              />
            </Page.SliderValue>
          </Page.SliderContainer>
        </>
      )}
    </>
  )
}

export default inject('store')(observer(ExtendedLifeExpectancy))
